module.exports = __webpack_public_path__ + "img/shandianzhuanfa_yidong.318e3481.png";